import { FC } from 'react';
import { EmptyWardrobeInfoModalPropsIF } from '@/components/elems/EmptyWardrobeInfoModal/EmptyWardrobeInfoModal.types';
import DialogModal from '@/components/interactive/DialogModal/DialogModal.component';

const EmptyWardrobeInfoModal: FC<EmptyWardrobeInfoModalPropsIF> = ({
    onClose,
    openPhotoWidget,
}) => {
    const acceptHandler = (isAccept: boolean): void => {
        if (isAccept) {
            openPhotoWidget();
        }

        onClose();
    };

    return (
        <DialogModal
            icon={<></>}
            title={
                <div className="flcol">
                    <span>Образ пока недоступен</span>
                    <br />
                    <span>
                        Чтобы собрать образ, сначала добавьте изделия в свой
                        гардероб
                    </span>
                </div>
            }
            buttonLabels={{ yes: 'Добавить изделие', no: 'Закрыть' }}
            handleDialogAccept={acceptHandler}
        />
    );
};

export default EmptyWardrobeInfoModal;
